import React from 'react';
import { Box, styled, Typography } from '@mui/material';

const Wrapper = styled(Box)(({ theme }) => ({
    paddingTop: '5px'
}));

export const FooterItemContentStyle: React.FC<{ children: React.ReactNode }> = (props) => {
    return (
        <Wrapper>
            {props.children}
        </Wrapper>
    );
};
